/**
 * SessionList - Landing page showing active server sessions
 */

import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { config } from '../../config';

export function SessionList() {
  const [sessions, setSessions] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch(`${config.apiUrl}/api/sessions`)
      .then(res => res.json())
      .then(data => {
        setSessions(data.sessions || []);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.message}>Loading sessions...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={styles.container}>
        <div style={styles.error}>Failed to load sessions: {error}</div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Tweakable</h1>
      <div style={styles.subtitle}>Select a session to join</div>

      {sessions.length === 0 ? (
        <div style={styles.empty}>No active sessions. Start a REPL to create one.</div>
      ) : (
        <div style={styles.list}>
          {sessions.map(session => (
            <Link key={session} to={`/${session}`} style={styles.sessionLink}>
              {session}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    background: '#111827',
    color: 'white',
    fontFamily: 'system-ui, -apple-system, sans-serif'
  },
  title: {
    fontSize: 32,
    fontWeight: 600,
    marginBottom: 8
  },
  subtitle: {
    fontSize: 14,
    color: '#9ca3af',
    marginBottom: 32
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12
  },
  sessionLink: {
    padding: '12px 24px',
    background: '#1f2937',
    borderRadius: 8,
    color: '#60a5fa',
    textDecoration: 'none',
    fontSize: 16,
    transition: 'background 0.2s'
  },
  empty: {
    color: '#6b7280',
    fontSize: 14
  },
  message: {
    color: '#9ca3af'
  },
  error: {
    color: '#ef4444'
  }
};
